const ScoreRange = {
    INTELLECTUAL_CAPABILITY: {
        MIN: 1,
        MAX: 5
    },
    INTELLECTUAL_CAPABILITY_EXTENDED: {
        MIN: 1,
        MAX: 5
    },
    ABILITY_TO_CHANGE: {
        MIN: 1,
        MAX: 5
    },
    APPENDIXES: {
        MIN: 1,
        MAX: 5
    },
    THINKING_CAPACITY: {
        MIN: 1,
        MAX: 5
    },
    DEALING_WITH_RESISTANCE: {
        MIN: 1,
        MAX: 7
    },
    WORK_SAFELY: {
        MIN: 1,
        MAX: 7
    }
};

export default ScoreRange;
